"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _QrScannerOverlay = _interopRequireDefault(require("./QrScannerOverlay.scss"));

var _strings = require("./strings");

var _Button = _interopRequireDefault(require("../Button"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This overlay is exclusively used by QRCode.scanQrCode()
 * If you want to scan an QR Code use that static function.
 */
var QRScannerOverlay = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(QRScannerOverlay, _React$PureComponent);

  var _super = _createSuper(QRScannerOverlay);

  function QRScannerOverlay() {
    (0, _classCallCheck2["default"])(this, QRScannerOverlay);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(QRScannerOverlay, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].outer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].inner
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].solidBackground
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].headline
      }, this.props.headline || (0, _strings.getString)('QR_SCANNER_HEADLINE')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].infotext
      }, this.props.infotext || (0, _strings.getString)('QR_SCANNER_INFOTEXT'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].scannerSquare
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].innerSquare
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].solidBackground
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QrScannerOverlay["default"].cancelButtonOuter
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this.props.onCancel,
        showBorder: true
      }, (0, _strings.getString)('CANCEL'))))));
    }
  }]);
  return QRScannerOverlay;
}(_react["default"].PureComponent);

QRScannerOverlay.propTypes = {
  onCancel: _propTypes["default"].func.isRequired,
  headline: _propTypes["default"].string,
  infotext: _propTypes["default"].string
};
var _default = QRScannerOverlay;
exports["default"] = _default;